module.exports = function ifPayYourBillLink(linkUrl, options) {
  if (!linkUrl || !linkUrl.includes('/creditservice/creditacct/paybill')) {
    return options.inverse(this);
  }

  return options.fn(this);
};



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/Polaris/header-footer-wgl/polaris_deploy_header-footer-wgl_deployable_pipeline/package/node_modules/@feature/footer/src/helpers/ifPayYourBillLink.js